export class LoginInfo {

  public static readonly TYPE_DEFAULT: string | undefined = undefined;
  public static readonly TYPE_CDC: string = 'CDC'; // SAP Customer Data Cloud (aka gigya)

  private _type: string | undefined = LoginInfo.TYPE_DEFAULT;
  private _username: string | undefined = undefined;
  private _password: string | undefined = undefined;

  //SAP CDC security attributes:
  private _cdcUID: string | undefined = undefined;
  private _cdcSignature: string | undefined = undefined;
  private _cdcTimestamp: string | undefined = undefined;

  public constructor(username: string | undefined, password: string | undefined, type: string | undefined) {
    this._type = type;
    this._username = username;
    this._password = password;
  }

  public get type(): string | undefined {
    return this._type;
  }

  public get username(): string | undefined {
    return this._username;
  }

  public get password(): string | undefined {
    return this._password;
  }

  public get cdcUID(): string | undefined {
    return this._cdcUID;
  }
  public set cdcUID(value: string) {
    this._cdcUID = value;
  }

  public get cdcSignature(): string | undefined {
    return this._cdcSignature;
  }
  public set cdcSignature(value: string) {
    this._cdcSignature = value;
  }

  public get cdcTimestamp(): string | undefined {
    return this._cdcTimestamp;
  }
  public set cdcTimestamp(value: string) {
    this._cdcTimestamp = value;
  }

}
